<!-- TBD / TODO: try to implement clean link / click event solution across all cards (?!) -->
<ng-container *ngIf="link; else cardTemplate">
  <ng-container [ngSwitch]="link.type">
    <a *ngSwitchCase="linkTypes.ROUTER" class="card-container" [routerLink]="link.url">
      <ng-container *ngTemplateOutlet="cardTemplate"></ng-container>
    </a>
    <a *ngSwitchCase="linkTypes.PROGRAMMATIC" class="card-container" (click)="linkAction($event)">
      <ng-container *ngTemplateOutlet="cardTemplate"></ng-container>
    </a>
    <a *ngSwitchCase="linkTypes.EXTERNAL" class="card-container" [href]="link.url" [target]="link.target">
      <ng-container *ngTemplateOutlet="cardTemplate"></ng-container>
    </a>
    <div *ngSwitchCase="linkTypes.NONE" class="card-container">
      <ng-container *ngTemplateOutlet="cardTemplate"></ng-container>
    </div>
  </ng-container>
</ng-container>

<ng-template #cardTemplate>
  <wb-card [attr.variant]="darkTheme ? 'dark-grey' : null" interactive>
    <figure>
      <div [ngSwitch]="eventState" class="topline">
        <div class="event-status">
          <ng-container *ngSwitchCase="eventStates.UPCOMING">
            <mb-small-spinner></mb-small-spinner>
            <wb-text size="s" *ngIf="distance">
              {{ 'EVENT_CARD_STARTS_IN' | translate : { distance: distance } }}
            </wb-text>
          </ng-container>

          <ng-container *ngSwitchCase="eventStates.RUNNING">
            <mb-live-indicator></mb-live-indicator>
            <wb-text size="s">{{ 'EVENT_CARD_RUNNING' | translate }}</wb-text>
          </ng-container>
        </div>

        <span *ngIf="attendanceStatus" [class]="'mb-icon ' + attendancesToIconMap[attendanceStatus]"></span>
      </div>

      <ng-container>
        <mb-media
          *ngIf="image && !showImageFallback"
          [media]="image"
          [hoverplay]="true"
          (imageError)="showImageFallback = true"
        ></mb-media>
        <img *ngIf="!image || showImageFallback" src="assets/img/fallbacks/Mercedes-Benz_4_3_800.png" />
      </ng-container>
    </figure>

    <div class="card-content">
      <div class="content-text">
        <wb-text size="m" *ngIf="titleHash"> {{ titleHash }} </wb-text>
        <wb-heading *ngIf="headline" size="xs">{{ headline }}</wb-heading>
        <time *ngIf="startDate && endDate" [attr.start]="startDate" [attr.end]="endDate">
          <wb-text size="m">{{ startDate | timePeriod : endDate : timezoneOffset }}</wb-text>
        </time>
        <wb-text size="m" class="registration-deadline" *ngIf="registrationDeadline && isPending()">
          {{
            'EVENT_RIBBON_CARD_EMBARGO_UNTIL' | translate : { date: registrationDeadline | localizedDate : 'longDate' }
          }}
        </wb-text>
      </div>
      <div *ngIf="location" class="location">
        <wb-icon name="bds/location/24"></wb-icon>
        <wb-text tag="p" size="s" class="location-text" static> {{ location }} </wb-text>
      </div>
    </div>
  </wb-card>
</ng-template>
